export const subjectShortForm = (
  subjectAbbr: string,
  grade: string | number
): string => `${subjectAbbr} ${grade}`;
